<template>
  <div class="input-wrapper" @click="handleEditText">
    <Icon v-if="!editText && !model" iconName="pen_16" />
    <p v-if="!editText">{{ model }}</p>
    <el-input
      ref="input"
      v-show="editText"
      v-model="model"
      size="small"
      @keyup.enter.native="changeValue"
      @blur="changeValue"
    />
  </div>
</template>
<script>
import Icon from 'Elements/Icon/Icon';
import { Input } from 'element-ui';
export default {
  props: {
    text: String
  },
  created() {
    this.model = this.text;
  },
  data() {
    return {
      model: '',
      editText: false
    };
  },
  methods: {
    handleEditText() {
      this.editText = true;
      setTimeout(() => {
        this.$refs.input.focus();
      }, 0);
    },
    changeValue(event) {
      this.model = event.srcElement.value;
      this.editText = false;
      this.$emit('changeValue', this.model);
    }
  },
  components: { 'el-input': Input, Icon }
};
</script>
<style lang="scss" scoped>
.input-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    min-width: 16px;
    width: 16px;
    height: 16px;
  }
}
</style>
